var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlarmzIcn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 198,
    height: 198,
    viewBox: "0 0 198 198",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 198,
    height: 198,
    fill: "#563C9D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.925 43.5883C94.8055 49.5585 90.2329 57.2872 88.0961 66.2418C82.1231 91.2792 97.4014 116.378 122.219 122.299C132.593 124.774 142.985 123.489 152.012 119.346C142.062 144.57 115.021 159.332 88.1105 152.913C58.5943 145.872 40.4232 116.02 47.527 86.2427C53.5905 60.8272 76.1061 43.6887 100.925 43.5883Z",
    fill: "#FECF00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarmzIcn);
export default __webpack_public_path__ + "static/media/alarmz_icn.dc813558e93581337c0a2078d64b17d5.svg";
export { ForwardRef as ReactComponent };